import moment from 'moment';

import {
    FETCH_AGENT_LOGS,
    FETCH_AGENT_LOG_ENTRIES,
    FETCH_DEVICES_AND_OBJECTS,
    RESET_AGENT_LOG_FILTERS,
    SET_AGENT_LOG_END_TIMESTAMP,
    SET_AGENT_LOG_META_DATA,
    SET_AGENT_LOG_SEARCH_VALUE,
    SET_AGENT_LOG_START_TIMESTAMP,
    SET_AGENT_LOG,
    SET_PROFILE_OBJECT_PROCESS_DATA,
    SET_PROFILE_OBJECT_PROCESS_IDS
} from '../actions/actionTypes';

const initialState = {
    deviceObjects:     [],
    logs:              [],
    logEntries:        null,
    logEndTimeStamp:   moment().local(),
    logSearchValue:    '',
    logStartTimeStamp: moment().subtract(1,'h').local().startOf('hour'),
    metaLogData:       {
        recordsMatched:    0,
        returnRecordCount: 0
    },
    profileObjectProcessData: [],
    profileObjectProcessIds:  [],
    selectedLog:              {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_AGENT_LOGS:
            return {
                ...state,
                logs: [...action.payload]
            };
        case FETCH_AGENT_LOG_ENTRIES:
            return {
                ...state,
                logEntries: action.payload ? [...action.payload] : null
            };
        case FETCH_DEVICES_AND_OBJECTS:
            return {
                ...state,
                deviceObjects: [...action.payload]
            };
        case RESET_AGENT_LOG_FILTERS:
            return {
                ...state,
                logEndTimeStamp:   moment().local(),
                logSearchValue:    '',
                logStartTimeStamp: moment().subtract(1,'h').local().startOf('hour')
            };
        case SET_AGENT_LOG:
            return {
                ...state,
                selectedLog: {...action.payload}
            };
        case SET_AGENT_LOG_META_DATA:
            return {
                ...state,
                metaLogData: {...action.payload}
            };
        case SET_AGENT_LOG_END_TIMESTAMP:
            return {
                ...state,
                logEndTimeStamp: action.payload
            };
        case SET_AGENT_LOG_SEARCH_VALUE:
            return {
                ...state,
                logSearchValue: action.payload
            };
        case SET_AGENT_LOG_START_TIMESTAMP:
            return {
                ...state,
                logStartTimeStamp: action.payload
            };
        case SET_PROFILE_OBJECT_PROCESS_DATA:
            return {
                ...state,
                profileObjectProcessData: [...action.payload]
            };
        case SET_PROFILE_OBJECT_PROCESS_IDS:
            return {
                ...state,
                profileObjectProcessIds: [...action.payload]
            };
        default:
            return state;
    }
};
